import { render, staticRenderFns } from "./WAddServicesDialog.vue?vue&type=template&id=ae7cd7bc&scoped=true&"
import script from "./WAddServicesDialog.vue?vue&type=script&lang=js&"
export * from "./WAddServicesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7cd7bc",
  null
  
)

export default component.exports